import { useContext, useEffect } from 'react';
import { MiniCardGrafico } from './MiniCardGrafico';
import { useSolicitudCoberturaIniciadoAutorizadoTotales } from '../hooks';
import { SolicitudCoberturaContext } from '../context';
import dayjs from 'dayjs';
import { GraficoLine } from './GraficoLine';
import { Grid } from '@mui/material';

export const IniciadoAutorizadoAnualLineaTotal = () => {
  const { anualList, anualDate } = useContext(SolicitudCoberturaContext);
  const { dataIniciadosAnual, dataAutorizadosAnual, getTramitesAnual } =
    useSolicitudCoberturaIniciadoAutorizadoTotales({
      anualList,
      anualDate,
    });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getTramitesAnual();
    }
  }, [anualList, anualDate]);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataAutorizadosAnual?.total || 0}
          title={
            <>
              <span>Autorizadas</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataAutorizadosAnual?.labels || []}
            datasets={dataAutorizadosAnual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
    </>
  );
};
